import { Directive, Input, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { escapeRegexp } from 'ngx-bootstrap/typeahead';
import { Static } from '../util/static';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[thousandsSeparator]',
})
export class ThousandsSeparatorDirective {
  @Input('thousandsSeparator') set thousandsSeparator(separator: FormControl) {
    this._thousandsSeparator = separator;
    if (this.suffixThousandsSeparator && this.suffixDecimalseparator) {
      this.format(separator);
    }
  }
  @Input('suffixThousandsSeparator') set suffixThousandsSeparator(sts: string) {
    this._suffixThousandsSeparator = sts;
    if (this.thousandsSeparator && this.suffixDecimalseparator) {
      this.format(this.thousandsSeparator);
    }
  }
  @Input('suffixDecimalseparator') set suffixDecimalseparator(sds: string) {
    this._suffixDecimalseparator = sds;
    if (this.suffixThousandsSeparator && this.thousandsSeparator) {
      this.format(this.thousandsSeparator);
    }
  }

  private _thousandsSeparator: FormControl;
  private _suffixThousandsSeparator: string;
  private _suffixDecimalseparator: string;

  get thousandsSeparator(): FormControl {
    return this._thousandsSeparator;
  }

  get suffixThousandsSeparator(): string {
    return this._suffixThousandsSeparator;
  }
  get suffixDecimalseparator(): string {
    return this._suffixDecimalseparator;
  }

  constructor(private el: ElementRef) {}

  /**
   * Aplica el formato a el valor de entrada y se suscribe a los cambios para aplicar el formato
   *
   * @private
   * @param {FormControl} c
   * @memberof ThousandsSeparatorDirective
   */
  private format(c: FormControl) {
    const value = c.value;
    if (value && String(value)) {
      c.setValue(
        Static.applyThousandsSeparatorFormat(
          typeof value === 'number' ? value : value.replace(/[^\d\,\.]/, ''),
          this.suffixThousandsSeparator,
          this.suffixDecimalseparator as any
        ),
        {
          onlySelf: false,
          emitEvent: false,
          emitModelToViewChange: true,
          emitViewToModelChange: true
        }
      );
    }
    c.valueChanges.subscribe((valueC: any) => {
      if (valueC && String(valueC)) {
        c.setValue(
          Static.applyThousandsSeparatorFormat(
            typeof valueC === 'number' ? valueC : String(valueC).replace(/[^\d\,\.]/, ''),
            this.suffixThousandsSeparator,
            this.suffixDecimalseparator as any
          ),
          {
            onlySelf: false,
            emitEvent: false,
            emitModelToViewChange: true,
            emitViewToModelChange: true
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/thousands-separator.directive.ts